'use strict';

const LIST_SELECTOR = '.js-artist-list';
const BTN_SELECTOR = '.js-artist-list-more';
const PAGE_SIZE = 6;

function initSection(list) {
    const items = Array.from(list.querySelectorAll('.child-list__page'));

    if (items.length <= PAGE_SIZE) {
        return;
    }

    items.slice(PAGE_SIZE).forEach(item => {
        item.hidden = true;
    });

    let shown = PAGE_SIZE;

    const btn = list.parentElement.querySelector(BTN_SELECTOR);

    if (!btn) return;

    btn.removeAttribute('hidden');

    btn.addEventListener('click', function () {
        const next = items.slice(shown, shown + PAGE_SIZE);

        next.forEach(item => {
            item.hidden = false;
        });

        shown += next.length;

        if (shown >= items.length) {
            btn.hidden = true;
            const firstNew = next[0]?.querySelector('a, button, [tabindex]') ?? next[0];
            if (firstNew) firstNew.focus();
        }
    });
}

export function init() {
    document.querySelectorAll(LIST_SELECTOR).forEach(initSection);
}
